import { always, equals, cond, T, pathOr, includes } from 'ramda';
import React from 'react';
import {
  PURCHASE,
  REFINANCE,
  CONSTRUCTION_LOAN,
  PRE_QUALIFICATION,
  CONDOMINIUM,
  MANUFACTURED_HOME,
  SINGLE_FAMILY,
  TOWNHOUSE,
  TWO_PROPERTY,
  PURCHASE_NEW_HOME,
  TERM_LOAN_ALL_CAPS,
  LINE_OF_CREDIT_ALL_CAPS,
  MULTI_FAMILY,
  PUD,
  HOME_EQUITY,
  HOME_EQUITY_TERM,
  HOME_EQUITY_REVOLVING,
  HOME_EQUITY_LINE_OF_CREDIT,
  HOME_REFINANCE,
  CASHOUT_REFINANCE,
  HOME_IMPROVEMENT,
  PAYOFF_DEBT,
  DEBT_CONSOLIDATION,
  PURCHASE_OTHER_PERSONAL_EQUIPMENT,
  OTHER,
  PURCHASE_AUTO,
  PURCHASE_RV,
  PURCHASE_MOTORCYCLE,
  PURCHASE_BOAT_TRAILER,
  OTHER_PERSONAL,
  CAR_TRUCK_SUV,
  MOTOR_HOME,
  BOAT_AND_TRAILER_OUTBOARD,
  BOAT_AND_TRAILER_INBOARD,
  HAULING_TRAILER,
  CREDIT_CARD_PAYOFF,
  MOVING_EXPENSES,
  MAJOR_PURCHASE,
  BUSINESS_LOAN,
  LOAN_CONSOLIDATION,
  SOLAR_LOAN,
  APPLICANT_AND_CO_APPLICANT_NAME,
  APPLICANT_NAME,
  TITLES_OWNED_BY_OTHERS,
  PRIMARY_RESIDENCE,
  SECOND_VACATION_HOME,
  INVESTMENT_RENTAL,
  AFFIXED_TO_EXISTING_STRUCTURE,
  STAND_ALONE_SYSTEM,
  MOTORCYCLE_ATV_UTV,
  CAR_TRUCK_SUV_MBWI,
  MOTORCYCLE_ATV_UTV_MBWI,
  CREDIT_CARD_RATE,
  CREDIT_CARD_BONUS,
  VISA_PLATINUM_CREDIT_CARD,
  DEPOSIT_ACCOUNT,
  TERM_LOAN,
  BUY_AN_EXISTING_BUSINESS,
  BUYING_OUT_PARTNER,
  PURCHASING_EQUIPMENT,
  EXPANSION,
  LEASE_INTEREST,
  MARKETING_ADVERTISING,
  PAYROLL,
  WORKING_CAPITAL,
  COOPERATIVE,
  REMODEL_LOCATION,
  FOUND_THE_HOME,
  LOOKING_FOR_HOME,
  THINK_ABOUT_BUYING,
  VISA_BUSINESS_CREDIT_CARD,
  VISA_PURCHASE_CARD,
  VISA_FLEED_CARD,
  BUSINESS_ACCOUNT,
  CONSUMER_ACCOUNT,
  CAR_SUV,
  BOAT_MOTOR_TRAILER,
  ACCOUNTS_RECEIVABLE,
  CASH_VALUE_LIFE_INSURANCE,
  INTREST_ONLY,
  PRINCIPAL_INTREST,
  PURCHASE_OTHER,
  STOCKS_BONDS_BROKERAGE,
  STOCKS_BONDS_BROKERAGE_WITH_SPACE,
  PRIMARY,
  INVESTMENT,
  RV,
  CHECKING,
  SAVINGS,
  SENIOR_CHECKING,
  CHECKING_WITH_INTEREST,
  RELATIONSHIP_CHECKING,
  MONEY_MARKET,
  PERSONAL_PROPERTY,
  PURCHASE_PERSONAL_PROPERTY,
  FINANCE_AUTO,
  FINANCE_BOAT_TRAILER,
  FINANCE_MOTORCYCLE,
  MISC,
  FINANCE_RV,
  MOBILE_HOME,
  PERSONAL_REVOLVING_LINE_OF_CREDIT,
  CASH_SECURED,
  HOME_EQUITY_LOAN
} from 'src/features/LoansHome/Products/constants';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import NewResidentialMortgage from 'src/assets/icons/icon_home.svg';
import ConstructionLoan from 'src/assets/icons/construction.svg';
import NewRefinanceMortgage from 'src/assets/icons/icon_refinance.svg';
import NewHelocMortgage from 'src/assets/icons/equity.svg';
import SingleFamily from 'src/assets/icons/icon_house-alt.svg';
import MultiFamily from 'src/assets/icons/icon_cohort.svg';
import TownHouse from 'src/assets/icons/icon_townhouse.svg';
import Condominium from 'src/assets/icons/icon_condominium.svg';
import ManufacturedHome from 'src/assets/icons/Manufactured.svg';
import InvestmentProperty from 'src/assets/icons/investment_property.svg';
import Cash from 'src/assets/icons/cash.svg';
import Other from 'src/assets/icons/other_icon.svg';
import LineOfCredit from 'src/assets/icons/lineofcredit.svg';
import TermLoan from 'src/assets/icons/term-loan.svg';
import NewSecuredLoan from 'src/assets/icons/icon_secured.svg';
import CashSecured from 'src/assets/icons/secured-money.svg';
import NewUnsecuredLoan from 'src/assets/icons/icon_unsecured.svg';
import Pud from 'src/assets/icons/pud.svg';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useProductOptionStyles } from 'src/features/LoansHome/Products/ProductOption';
import { UNSECURED, SECURED } from 'src/features/LoansHome/Products/constants';
import { styled, useTheme } from '@mui/material/styles';
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import DebtConsolidation from 'src/assets/icons/debt_consolidation.svg';
import HomeImprovement from 'src/assets/icons/home_improvement.svg';
import RvVehicle from 'src/assets/icons/rv_vehicle.svg';
import ToolBox from 'src/assets/icons/toolbox.svg';
import Vehicle from 'src/assets/icons/vehicle.svg';
import ExistingStructure from 'src/assets/icons/existing_structure.svg';
import StandAloneSystem from 'src/assets/icons/standalone_system.svg';
import Motorcycle from 'src/assets/icons/motorcycle.svg';
import Boat from 'src/assets/icons/boat.svg';
import Trailer from 'src/assets/icons/trailer.svg';
import CreditCardPayoff from 'src/assets/icons/credit-card.svg';
import Link from 'src/assets/icons/link.svg';
import Key from 'src/assets/icons/key.svg';
import Store from 'src/assets/icons/store.svg';
import BusinessLoan from 'src/assets/icons/business-loan.svg';
import SolarPanel from 'src/assets/icons/solar-loan.svg';
import ApplicantIcon from 'src/assets/icons/applicant.svg';
import CoApplicantIcon from 'src/assets/icons/co-applicant.svg';
import TitlesIcon from 'src/assets/icons/title.svg';
import PrimaryResidenceIcon from 'src/assets/icons/icon_primary_residence.svg';
import SecondaryHomeIcon from 'src/assets/icons/icon_secondary_home.svg';
import InvestmentPropertyIcon from 'src/assets/icons/icon_Investment_property.svg';
import CreditCardBonus from 'src/assets/icons/credit_card_bonus.svg'
import LookingForHome from 'src/assets/icons/looking_for_home.svg'
import BuyingHome from 'src/assets/icons/think_about_buying_home.svg'
import FoundTheHome from 'src/assets/icons/found_the_home.svg';
import Card from 'src/assets/icons/card.svg';
import InterestRate from 'src/assets/icons/interest.svg';
import Principal from 'src/assets/icons/principal.svg';
import Stocks from 'src/assets/icons/stocks.svg';
import Checking from 'src/assets/icons/checking_account.svg';
import Saving from 'src/assets/icons/saving_account.svg';
import RelationshipChecking from 'src/assets/icons/relationship_checking.svg';
import SeniorChecking from 'src/assets/icons/senior_checking.svg';
import OverflowTooltip from 'src/components/OverflowTooltip/OverflowTooltip';
import useMediaQuery from '@mui/material/useMediaQuery';
import { createMarkup } from 'src/features/utilities';
import { buildLabel } from 'src/utilities/naming';
import { isNotEmpty } from 'src/utilities/hasValue';
import { TRUE } from 'src/constants';


export interface ProductProps {
  product: any;
  onSelect: any;
  option?: any;
  active?: any;
  intent?: any;
  showCardHorizonal?: any;
}
const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    disableFocusListener
    enterTouchDelay={0}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.gray.darkGray,
    color: theme.palette.basic.white,
    boxShadow: theme.shadows[1],
    fontSize: 14,
  },
}));

export type CombinedProductCardProps = ProductProps & RouteComponentProps<{}>;

const ProductCard: React.FC<CombinedProductCardProps> = (props) => {
  const { onSelect, active, product, showCardHorizonal, intent } = props;
  const display_text = pathOr(pathOr('', ['label'], product), ['display_it_as'], product);
  const display_name = pathOr(display_text, ['display_label'], product)
  const mobileCenterAlign = equals(TRUE, pathOr("", ['metadata', "mobile_center_align"], intent))
  const updateItAsText = pathOr('', ['update_it_as'], product);
  const descriptionAlignment = pathOr('left', ['metadata', buildLabel("options_description_alignment")], intent);
  const descriptionText = pathOr('', ['description'], product);
  const classes = useProductOptionStyles(active, showCardHorizonal, descriptionAlignment, isNotEmpty(descriptionText))();
  const tooltipText = pathOr('', ['tooltipMessage'], product);
  const { breakpoints } = useTheme();
  const matches = useMediaQuery(breakpoints.down('md'));
  const productAsVisual = (display_text: string) => {
    return cond([
      [() => includes(display_text, [PURCHASE, PURCHASE_NEW_HOME]), always(<NewResidentialMortgage />)],
      [equals(REFINANCE), always(<NewRefinanceMortgage />)],
      [() => includes(display_text, [PRE_QUALIFICATION, HOME_EQUITY, HOME_EQUITY_LOAN]), always(<NewHelocMortgage />)],
      [equals(SINGLE_FAMILY), always(<SingleFamily />)],
      [() => includes(display_text, [CONDOMINIUM, WORKING_CAPITAL]), always(<Condominium />)],
      [() => includes(display_text, [TWO_PROPERTY, MULTI_FAMILY]), always(<MultiFamily />)],
      [() => includes(display_text, [COOPERATIVE, REMODEL_LOCATION, TOWNHOUSE]), always(<TownHouse />)],
      [equals(MANUFACTURED_HOME), always(<ManufacturedHome />)],
      [() => includes(display_text, [HOME_REFINANCE, MARKETING_ADVERTISING]), always(<InvestmentProperty />)],
      [() => includes(display_text, [HOME_IMPROVEMENT, LEASE_INTEREST]), always(<HomeImprovement />)],
      [() => includes(display_text, [PAYROLL, PAYOFF_DEBT, ACCOUNTS_RECEIVABLE, DEPOSIT_ACCOUNT, CASHOUT_REFINANCE, CASH_VALUE_LIFE_INSURANCE]), always(<Cash />)],
      [() => includes(display_text, [TERM_LOAN_ALL_CAPS, HOME_EQUITY_TERM, TERM_LOAN]), always(<TermLoan />)],
      [() => includes(display_text, [LINE_OF_CREDIT_ALL_CAPS, HOME_EQUITY_REVOLVING, HOME_EQUITY_LINE_OF_CREDIT]), always(<LineOfCredit />)],
      [() => includes(display_text, [OTHER, OTHER_PERSONAL, PURCHASE_OTHER, PURCHASE_PERSONAL_PROPERTY, PERSONAL_PROPERTY, MISC]), always(<Other />)],
      [() => includes(display_text, [INTREST_ONLY]), always(<InterestRate />)],
      [() => includes(display_text, [PRINCIPAL_INTREST]), always(<Principal />)],
      [() => includes(display_text, [STOCKS_BONDS_BROKERAGE, STOCKS_BONDS_BROKERAGE_WITH_SPACE]), always(<Stocks />)],
      [equals(UNSECURED), always(<NewUnsecuredLoan />)],
      [equals(SECURED), always(<NewSecuredLoan />)],
      [equals(PERSONAL_REVOLVING_LINE_OF_CREDIT), always(<CashSecured />)],
      [equals(CASH_SECURED), always(<CashSecured />)],
      [equals(PUD), always(<Pud />)],
      [equals(DEBT_CONSOLIDATION,), always(<DebtConsolidation />)],
      [() => includes(display_text, [PURCHASE_OTHER_PERSONAL_EQUIPMENT, PURCHASING_EQUIPMENT]), always(<ToolBox />)],
      [() => includes(display_text, [PURCHASE_RV, MOTOR_HOME, RV, FINANCE_RV]), always(<RvVehicle />)],
      [equals(AFFIXED_TO_EXISTING_STRUCTURE), always(<ExistingStructure />)],
      [equals(STAND_ALONE_SYSTEM), always(<StandAloneSystem />)],
      [() => includes(display_text, [CAR_TRUCK_SUV, CAR_TRUCK_SUV_MBWI, CAR_SUV, PURCHASE_AUTO, FINANCE_AUTO]), always(<Vehicle />)],
      [() => includes(display_text, [BOAT_AND_TRAILER_INBOARD, BOAT_AND_TRAILER_OUTBOARD, BOAT_MOTOR_TRAILER, PURCHASE_BOAT_TRAILER, FINANCE_BOAT_TRAILER]), always(<Boat />)],
      [equals(HAULING_TRAILER), always(<Trailer />)],
      [() => includes(display_text, [MOTORCYCLE_ATV_UTV, MOTORCYCLE_ATV_UTV_MBWI, PURCHASE_MOTORCYCLE, FINANCE_MOTORCYCLE]), always(<Motorcycle />)],
      [equals(LOAN_CONSOLIDATION), always(<Link />)],
      [() => includes(display_text, [MOVING_EXPENSES, EXPANSION]), always(<Store />)],
      [equals(MAJOR_PURCHASE), always(<Key />)],
      [() => includes(display_text, [BUSINESS_LOAN, BUY_AN_EXISTING_BUSINESS, BUSINESS_ACCOUNT]), always(<BusinessLoan />)],
      [equals(SOLAR_LOAN), always(<SolarPanel />)],
      [() => includes(display_text, [APPLICANT_AND_CO_APPLICANT_NAME, BUYING_OUT_PARTNER]), always(<CoApplicantIcon />)],
      [equals(APPLICANT_NAME), always(<ApplicantIcon />)],
      [equals(TITLES_OWNED_BY_OTHERS), always(<TitlesIcon />)],
      [() => includes(display_text, [PRIMARY_RESIDENCE, PRIMARY]), always(<PrimaryResidenceIcon />)],
      [equals(SECOND_VACATION_HOME), always(<SecondaryHomeIcon />)],
      [() => includes(display_text, [INVESTMENT_RENTAL, INVESTMENT]), always(<InvestmentPropertyIcon />)],
      [equals(VISA_PLATINUM_CREDIT_CARD), always(<Card className={classes.paletteCreditCard} />)],
      [equals(VISA_BUSINESS_CREDIT_CARD), always(<Card className={classes.businessCreditCard} />)],
      [equals(VISA_FLEED_CARD), always(<Card className={classes.fleetCreditCard} />)],
      [equals(VISA_PURCHASE_CARD), always(<Card className={classes.purchaseCreditCard} />)],
      [() => includes(updateItAsText, [VISA_BUSINESS_CREDIT_CARD, CREDIT_CARD_BONUS, VISA_PURCHASE_CARD]), always(<CreditCardBonus />)],
      [() => includes(updateItAsText, [VISA_PLATINUM_CREDIT_CARD, CREDIT_CARD_RATE, CREDIT_CARD_PAYOFF, VISA_FLEED_CARD]), always(<CreditCardPayoff />)],
      [() => includes(updateItAsText, [DEPOSIT_ACCOUNT, CONSUMER_ACCOUNT]), always(<Cash />)],
      [equals(CONSTRUCTION_LOAN), always(<ConstructionLoan />)],
      [() => includes(updateItAsText, [THINK_ABOUT_BUYING,]), always(<LookingForHome className={classes.homeBuyingOption} />)],
      [() => includes(updateItAsText, [LOOKING_FOR_HOME]), always(<BuyingHome className={classes.homeBuyingOption} />)],
      [() => includes(updateItAsText, [MOBILE_HOME]), always(<TownHouse />)],
      [() => includes(updateItAsText, [FOUND_THE_HOME]), always(<FoundTheHome className={classes.homeBuyingOption} />)],
      [() => includes(updateItAsText, [CHECKING]), always(<Checking />)],
      [() => includes(updateItAsText, [SAVINGS]), always(<Saving />)],
      [() => includes(updateItAsText, [RELATIONSHIP_CHECKING]), always(<RelationshipChecking />)],
      [() => includes(updateItAsText, [MONEY_MARKET]), always(<Stocks />)],
      [() => includes(updateItAsText, [SENIOR_CHECKING]), always(<SeniorChecking />)],
      [() => includes(updateItAsText, [CHECKING_WITH_INTEREST]), always(<InterestRate />)],
      [T, () => <SingleFamily />]
    ])(display_text);
  };

  return (
    <Box
      className={classes.card}
      onClick={() => {
        onSelect(product)
      }}
    >
      <Box className={classes.cardItemContainer} sx={{marginLeft: mobileCenterAlign ? "inherit":"0px !important" }}>
        <Box position="relative" className={classes.iconWrapper}>
          {productAsVisual(display_text)}
          <Box className={classes.lines}>
            <Box component="span" className={classes.topLine} />
            <Box component="span" className={classes.botLine} />
          </Box>
        </Box>
        <Box sx={{
          width: '100%',
          alignItems: 'center',
          display: matches && !showCardHorizonal ? 'flex' : 'block'
        }}>
          <Box className={classes.titleContainer}>
            <Typography className={classes.title} dangerouslySetInnerHTML={createMarkup(display_name)} />
          </Box>
          {descriptionText &&
            <Typography className={`${classes.description}`}>
              <OverflowTooltip title={descriptionText} classWrapper={classes.descriptionTruncate}>
                {descriptionText}
              </OverflowTooltip>
            </Typography>
          }
          <Box mt={1} sx={{
            textAlign: 'center'
          }}>
            {tooltipText &&
              <StyledTooltip title={tooltipText}>
                <HelpOutlineIcon color="primary" className={classes.helpIcon} />
              </StyledTooltip>}
          </Box>
        </Box>
      </Box>
    </Box >
  );
};



export default compose(withRouter)(ProductCard);
